import { LucideIcon } from 'lucide-react';

interface NavItem {
  title: string;
  href: string;
  icon: LucideIcon;
  badge?: number;
  disabled?: boolean;
  showBreadcrumbs?: boolean;
}

interface NavGroup {
  label: string;
  items: NavItem[];
  disabled?: boolean;
  // If collapsable is true, indicates whether the group can be expanded or collapsed
  collapsable?: boolean;
  // Indicates if the group is currently expanded (only relevant if collapsable is true)
  expanded?: boolean;
  // Function to expand or collapse the group (only relevant if collapsable is true)

  onExpandedChange?: (expanded: boolean) => void;
}

interface UserInfo {
  name: string;
  email?: string;
  role?: string;
  initials: string;
  avatarUrl?: string;
}

interface BrandingConfig {
  name: string;
  logo?: string;
  logoCollapsed?: string;
  bgColor?: string;
  textColor?: string;
}

interface NotificationItem {
  id: string;
  title: string;
  description?: string;
  timestamp: string;
  read?: boolean;
}

interface DashboardConfig {
  branding: BrandingConfig;
  navigation: NavGroup[];
  basePath: string;
  routeTitles?: Record<string, string>;
  user?: UserInfo;
  singleExpanded?: boolean;
  notifications?: NotificationItem[];
  onLogout?: () => void;
}

function generateRouteTitles(
  navigation: NavGroup[],
  basePath: string,
): Record<string, string> {
  const titles: Record<string, string> = {};

  navigation.forEach((group) => {
    group.items.forEach((item) => {
      titles[item.href] = item.title;
    });
  });

  if (!titles[basePath]) {
    titles[basePath] = 'Dashboard';
  }

  return titles;
}

export {
  type NavItem,
  type NavGroup,
  type UserInfo,
  type BrandingConfig,
  type NotificationItem,
  type DashboardConfig,
  generateRouteTitles,
};
